module.exports = __webpack_public_path__ + "static/media/log-out-outline.3eaf5b36.svg";